import dayjs from 'dayjs';

export const getRefundRemainingSeconds = (
  createdAt: string,
  refundHeadroomMinutes: number,
  now: number = Date.now()
): number =>
  refundHeadroomMinutes * 60 - dayjs(now).diff(dayjs(createdAt), 'seconds');
